import { PostHogExperiment } from "@/study-search/enums";
import store from "..";

declare const POST_HOG_EXPERIMENT_KEY: string;

export class PostHogExperimentsPlugin {
	public initiate(): void {
		if (!window.PostHog) {
			return;
		}

		window.PostHog.onFeatureFlags((flags, variants) => {
			this.checkForTargetExperiment(flags, variants);
		});
	}

	private checkForTargetExperiment(flags: string[], variants: Record<string, string | boolean>): void {
		const isTargetExperimentEnabled = flags.includes(POST_HOG_EXPERIMENT_KEY);

		if (!isTargetExperimentEnabled) return;
		if (!Object.prototype.hasOwnProperty.call(variants, POST_HOG_EXPERIMENT_KEY)) return;

		const featureFlagValue = window.PostHog.getFeatureFlag(POST_HOG_EXPERIMENT_KEY) as PostHogExperiment;
		store.mutations.storeCurrentPostHogExperiment(featureFlagValue);
	}
}